import React, { useState, useEffect } from "react";
import classes from "../customer.module.css";
import { useDispatch, useSelector } from "react-redux";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import {
  fetchTeams,
  getOneTeamDetails,
} from "../../../../Redux/actions/customerActions";
import TeamRow from "./TeamRow";
import FilterButton from "../../../../Components/Filters/FilterButton";
import FilterDrawer from "../../../../Components/Filters/FilterDrawer";
import StatusFilter from "../../../../Components/Filters/StatusFilter";
import { InvoiceFilterAction } from "../../../../Redux/actions/filterActions";

const TeamList = (props) => {
  const dispatch = useDispatch();
  const [expandedTeam, setExpandedTeam] = useState(null);

  const { sortBy, invoice } = useSelector((state) => state.filter);

  useEffect(() => {
    dispatch(fetchTeams(props.id));
  }, [props.id, dispatch]);

  useEffect(() => {
    if (expandedTeam) {
      dispatch(getOneTeamDetails(expandedTeam, sortBy, invoice));
    }
  }, [expandedTeam, sortBy, invoice, dispatch]);

  const teamsData = useSelector((state) => state.customerData);

  const { loading, errorteams, teams, oneTeamData } = teamsData || {};

  const [filterOpen, setFilterOpen] = useState(false);
  const activeCount = invoice?.length || 0;
  const handleClearAll = () => {
    dispatch(InvoiceFilterAction([]));
  };

  const handleToggle = (teamId) => {
    setExpandedTeam((prev) => (prev === teamId ? null : teamId));
  };

  return (
    <div className={classes.tableContainer}>
      <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "8px" }}>
        <FilterButton
          activeCount={activeCount}
          onClick={() => setFilterOpen(true)}
        />
      </div>
      <Table className={classes.MainTable}>
        <TableHead>
          <TableRow className={classes.tableHeadRow}>
            <TableCell />
            <TableCell className={classes.tableHeadCell}>Team Name</TableCell>
            <TableCell className={classes.tableHeadCell}>Members</TableCell>
          </TableRow>
        </TableHead>
      </Table>
      <Table>
        <TableBody>
          {loading && !teams?.length ? (
            <TableRow>
              <td colSpan="3" className="text-center">
                Loading...
              </td>
            </TableRow>
          ) : errorteams ? (
            <TableRow>
              <td colSpan="3" className="text-center">
                {errorteams}
              </td>
            </TableRow>
          ) : teams && teams.length > 0 ? (
            teams.map((team) => (
              <TeamRow
                key={team._id}
                team={team}
                expanded={expandedTeam === team._id}
                onToggle={() => handleToggle(team._id)}
                members={
                  expandedTeam === team._id ? oneTeamData?.members : null
                }
                loading={expandedTeam === team._id && loading}
                sortBy={sortBy}
              />
            ))
          ) : (
            <TableRow>
              <td colSpan="3" className="text-center">
                No Data Found
              </td>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <FilterDrawer
        open={filterOpen}
        onClose={() => setFilterOpen(false)}
        onClearAll={handleClearAll}
      >
        <StatusFilter label="Status" selected={invoice} />
      </FilterDrawer>
    </div>
  );
};

export default TeamList;
